import { apiConfig } from "./apiConfig";

const mostRecentPostsUrl = `${apiConfig.oftheday.recent}?page=1`;
const getPreviousPostsUrl = `${apiConfig.oftheday.recent}?filter=exclude_today&page=1`;

export const getMostRecentPosts = (axios) => axios.get(`${mostRecentPostsUrl}`);
export const getPreviousPosts = (axios) => axios.get(`${getPreviousPostsUrl}`);
